var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m195.096 59.178h-105.929c-16.542 0-30 13.458-30 30v105.933c0 16.542 13.458 30 30 30h105.93c16.542 0 30-13.458 30-30v-105.933c-.001-16.542-13.459-30-30.001-30zm-105.929 135.932v-105.932h105.93l.003 105.933z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.611 225.11h105.93c16.543 0 30-13.458 30-30v-105.932c0-16.542-13.457-30-30-30h-105.93c-16.542 0-30 13.458-30 30v105.933c0 16.541 13.458 29.999 30 29.999zm0-135.932h105.93l.004 105.933h-105.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.096 284.618h-105.929c-16.542 0-30 13.458-30 30v105.934c0 16.541 13.458 30 30 30h105.93c16.542 0 30-13.459 30-30v-105.934c-.001-16.542-13.459-30-30.001-30zm-105.929 135.933v-105.933h105.93l.003 105.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448.486 427.283-20.829-20.829c8.42-12.473 13.343-27.494 13.343-43.644 0-43.114-35.078-78.191-78.195-78.191-43.116 0-78.193 35.077-78.193 78.191 0 43.121 35.078 78.201 78.193 78.201 16.147 0 31.168-4.923 43.64-13.344l20.829 20.829c6.184 6.184 16.641 5.662 22.197-1.083 4.844-5.883 4.4-14.745-.985-20.13zm-37.495-64.477c0 26.613-21.573 48.188-48.187 48.188s-48.188-21.574-48.188-48.188 21.575-48.188 48.188-48.188 48.187 21.574 48.187 48.188z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory1);
export default __webpack_public_path__ + "static/media/category1.612fce26bb64c63bf290835372b8643b.svg";
export { ForwardRef as ReactComponent };